<template>

  <modalo
    :creating="creating"
    :title="null"
    type="medium"
    :padding="'0px'"
    @hideModal="hideModal()">

    <div class="vflex">
      <div class="vflex-row-1">

        <div
          v-if="!creating"  
          class="vflex">

          <div class="vflex-row-0 vflex-header p-3">
            <div class="page-title">
              <div class="title">
                <h4>{{ $t('Need approval') }}</h4>
              </div>
            </div>
          </div>

          <div class="vflex-row-1">
            <Paginaty
              :total="paginate.total"
              :pages="paginate.pages"
              :page="paginate.page"
              :creating="creating"
              :loading="loading"
              @changePage="loadData">
            
              <template slot="content">
                <ul class="list-group list-group-flush">
                  <approval-list-item
                    v-for="(approval, index) in approvals"
                    :key="index"
                    :approval="approval"
                    @updated="loadData(paginate.page)">
                    </approval-list-item>
                </ul>
              </template>

              <template slot="noresults">
                {{ $t('There are no items') }}
              </template>

            </Paginaty>
          </div>

        </div>

      </div>
    </div>
  </modalo>

</template>

<script>
import Paginaty from '@/components/Paginaty/Paginaty'
import ApprovalListItem from './ApprovalListItem'

export default {
  name: 'ApprovalList',
  components: {
    Paginaty,
    ApprovalListItem
  },
  data () {
    return {
      creating: true,
      loading: true,
      sort: 'date',
      filters: {}
    }
  },
  computed: {
    approvals () {
      return this.$store.getters.getApprovals
    },
    paginate () {
      return this.$store.getters.getApprovalsPaginate
    }
  },
  created () {
    this.loadData(1)
  },
  methods: {
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectApprovals', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    },
    setFilter (filters) {
      this.filters = {
        ...this.filters,
        ...filters
      }
      this.loadData(1)
    },
    hideModal () {
      this.$emit('hideModal')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Approval/ApprovalList.vue